import { FormlyModule } from '@ngx-formly/core';
import { FormlyMatToggleModule } from '@ngx-formly/material/toggle';
import { FormlyFieldButtonComponent } from './components/button-type.component';
import { NgPrimeModule } from './ng-prime/ng-prime.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyFieldFileComponent } from './components/input-file/formly-fieldfile.component';
import { FileValueAccessor } from './file-value-accessor';
import { FormlyChipsComponent } from './components/chips/formly-chips.component';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { MaterialDesignModule } from './material-design.module';
import { FormlyHorizontalWrapper } from './wrapers/wraper-horizontal/formly-horizontal-wrapper';
import { PhdSoftFormFlexLayoutComponent } from './components/form-flex/form-flex';
import { addonsExtension } from './wrapers/wraper-addons/formly-wrapper-addons.extension';
import { FormlyWrapperAddonsComponent } from './wrapers/wraper-addons/formly-wrapper-addons.component';
import { CustomInputComponent } from './components/custom-input/custom-input.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormlyRepeatSectionComponent } from './components/repeat-section/repeat-section';
import { FormlyRepeatSectionExpansionComponent } from './components/repeat-section-expansion/repeat-section-expansion';
import { WrapperCleanComponent } from './wrapers/wraper-clean/wraper-clean.component';
import { FormlyFileLinkComponent } from './components/file-link/formly-file-link.component';

export function requiredValidationMessage(err, field): string {
  return `${field.templateOptions.label} is required`;
}

export function minlengthValidationMessage(err, field): string {
  return `Should have at least ${field.templateOptions.minLength} characters`;
}

export function maxlengthValidationMessage(err, field): string {
  return `This value should be less than ${field.templateOptions.maxLength} characters`;
}

export function minValidationMessage(err, field): string {
  return `This value should be more than ${field.templateOptions.min}`;
}

export function maxValidationMessage(err, field): string {
  return `This value should be less than ${field.templateOptions.max}`;
}

const MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  MatExpansionModule,
];

const COMPONENTS = [
  FileValueAccessor,
  FormlyFieldFileComponent,
  FormlyChipsComponent,
  FormlyHorizontalWrapper,
  FormlyWrapperAddonsComponent,
  FormlyRepeatSectionComponent,
  FormlyRepeatSectionExpansionComponent,
  FormlyFieldButtonComponent,
  PhdSoftFormFlexLayoutComponent,
  CustomInputComponent,
  FormlyFileLinkComponent,
  WrapperCleanComponent,
];

@NgModule({
  imports: [
    ...MODULES,
    FormlyModule.forRoot({
      wrappers: [
        { name: 'addons', component: FormlyWrapperAddonsComponent },
        { name: 'horizontal', component: FormlyHorizontalWrapper },
        { name: 'clean', component: WrapperCleanComponent },
      ],
      extensions: [{ name: 'addons', extension: { onPopulate: addonsExtension } }],
      types: [
        {
          name: 'file-link',
          component: FormlyFileLinkComponent,
        },
        {
          name: 'custom',
          component: CustomInputComponent,
        },
        {
          name: 'pdhsoft-repeat-section',
          component: FormlyRepeatSectionComponent,
        },
        {
          name: 'pdhsoft-repeat-section-expansion',
          component: FormlyRepeatSectionExpansionComponent,
        },
        {
          name: 'pdhsoft-flex-layout',
          component: PhdSoftFormFlexLayoutComponent,
        },
        {
          name: 'file',
          component: FormlyFieldFileComponent,
          wrappers: ['form-field'],
        },
        {
          name: 'chips',
          component: FormlyChipsComponent,
          extends: 'input',
        },
        {
          name: 'button',
          component: FormlyFieldButtonComponent,
          defaultOptions: {
            templateOptions: {
              btnType: 'primary',
              type: 'button',
            },
          },
        },
      ],
      validationMessages: [
        { name: 'required', message: requiredValidationMessage },
        { name: 'minLength', message: minlengthValidationMessage },
        { name: 'maxLength', message: maxlengthValidationMessage },
        { name: 'min', message: minValidationMessage },
        { name: 'max', message: maxValidationMessage },
      ],
    }),
    FormlyMaterialModule,
    FormlyMatToggleModule,
    MaterialDesignModule,
    NgPrimeModule,
  ],
  exports: [...MODULES, FormlyModule, ...COMPONENTS],
  declarations: [...COMPONENTS],
})
export class FormlyBaseModule {}
